function recoveryFromHistory(historyRecord){
    let minigameData = historyRecord.minigame.form;
    let playerAns = historyRecord.playerAns;
    let isCompleted = historyRecord.completed;
    switch(minigameData.type){
        case "Question":
        case "ManyAnsQuestion":    
            return recoveryQuestion(minigameData, playerAns, historyRecord.minigame.name, historyRecord.minigame.title, isCompleted);
        default:
            return undefined;
    }
}

function recoveryQuestion(minigameData, playerAns, name, title, isCompleted){
    return {
        title,
        name,
        form: minigameData,
        playerAns,
        isCompleted
    }
}

export default recoveryFromHistory;